import { Link } from "react-router-dom";
import { cn } from "../../lib/utils";

export function Logo({
  className,
  textClassName,
  to = "/",
}: {
  className?: string;
  textClassName?: string;
  to?: string;
}) {
  return (
    <Link className={cn("inline-flex items-center gap-3 text-navy-900", className)} to={to}>
      <span className="grid h-9 w-9 flex-none grid-cols-2 gap-1 rounded-lg bg-navy-900 p-2 sm:h-10 sm:w-10" aria-hidden>
        <span className="rounded-sm bg-white" />
        <span className="rounded-sm bg-white" />
        <span className="rounded-sm bg-white" />
        <span className="rounded-sm bg-water-400" />
      </span>
      <span className={cn("text-lg font-bold tracking-normal sm:text-xl", textClassName)}>
        BaselineBoard<span className="font-medium">.app</span>
      </span>
    </Link>
  );
}
